import { render, staticRenderFns } from "./contractChangeAuditOrdersList.vue?vue&type=template&id=665751ab&scoped=true"
import script from "./contractChangeAuditOrdersList.vue?vue&type=script&lang=js"
export * from "./contractChangeAuditOrdersList.vue?vue&type=script&lang=js"
import style0 from "./contractChangeAuditOrdersList.vue?vue&type=style&index=0&id=665751ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665751ab",
  null
  
)

export default component.exports